const POSITIVE = '#9bbb59'
const NEUTRAL = '#a6a6a6'
const NEGATIVE = '#ff0200'
const DEFAULT_BAR = '#0a3579'
const DEFAULT_LINE = '#1e7bbb'
const TABLE_BACKGROUND = '#00a6f3'
const TABLE_BORDER = '#3bb4f6'
const TABLE_HEADER = '#000000'
const TABLE_DATA = '#feb236'
const APCO = '#f47c31'
const SENSIKA = '#001528'
const WHITE = '#ffffff'
const BLACK = '#000000'
const DARK_SHADOW = '#000000D0'
const LIGHT_SHADOW = '#7090B05F'
const LIGHT_GREY = '#5c5c5c'
const PURPLE = '#8E4095'
const EXPO_BAR_CHART = '#09357A'
const CYAN = '#00A2FF'
const GREEN = '#91C545'
const NAVY = '#335D77'
const FII_BAR_CHART = '#5582A0'

// fii map colors (?)
const ULTRA_RED = '#FF6985'
const CHROME_YELLOW = '#FFA600'
const BLUE_SAPPHIRE = '#1B6284'
const DARK_CYAN = '#008D87'
const PACIFIC_BLUE = '#38BBD4'
const SPRING_GREEN = '#6FF1AB'
const KEY_LIME = '#EDF983'
const SPACE_CADET ='#1D285C'
const AQUA = '#5CFFFF'
const BLUE_CRAYOLA = '#1384C4'
const LAVENDER = '#BB77D1'

const EXPO_POSITIVE = '#9BBB59'
const EXPO_NEGATIVE = '#FF0000'
const EXPO_NEUTRAL = '#A6A6A6'

const FII_POSITIVE = '#91C545'
const FII_NEGATIVE = '#FF0000'
const FII_NEUTRAL = '#A6A6A6'

export default {
    POSITIVE,
    NEUTRAL,
    NEGATIVE,
    DEFAULT_BAR,
    DEFAULT_LINE,
    TABLE_BACKGROUND,
    TABLE_BORDER,
    TABLE_HEADER,
    TABLE_DATA,
    APCO,
    WHITE,
    SENSIKA,
    DARK_SHADOW,
    LIGHT_SHADOW,
    BLACK,
    PURPLE,
    GREEN,
    NAVY,
    CYAN,
    LIGHT_GREY,
    ULTRA_RED,
    CHROME_YELLOW,
    BLUE_SAPPHIRE,
    DARK_CYAN,
    PACIFIC_BLUE,
    SPRING_GREEN,
    KEY_LIME,
    SPACE_CADET,
    AQUA,
    BLUE_CRAYOLA,
    LAVENDER,
    EXPO_POSITIVE,
    EXPO_NEGATIVE,
    EXPO_NEUTRAL,
    FII_POSITIVE,
    FII_NEGATIVE,
    FII_NEUTRAL,
    FII_BAR_CHART,
    EXPO_BAR_CHART
}